import React from "react";
import RequestDataTable from "../../../components/WindowDoor/RequestDataTable";

const DashboardHome = () => {
  return <RequestDataTable />;
};

export default DashboardHome;
